export default __webpack_public_path__ + "media/images/favicon-93e3bb73dc285617caa3f7ccd5e66e27.svg";